import { render, staticRenderFns } from "./CustomCarouselItem.vue?vue&type=template&id=bee85e3c&scoped=true"
import script from "./CustomCarouselItem.vue?vue&type=script&lang=js"
export * from "./CustomCarouselItem.vue?vue&type=script&lang=js"
import style0 from "./CustomCarouselItem.vue?vue&type=style&index=0&id=bee85e3c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee85e3c",
  null
  
)

export default component.exports